import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const breadcrumbsItemFn = /* @__PURE__ */ createRecipe('breadcrumbs-item', {}, [])

const breadcrumbsItemVariantMap = {}

const breadcrumbsItemVariantKeys = Object.keys(breadcrumbsItemVariantMap)

export const breadcrumbsItem = /* @__PURE__ */ Object.assign(memo(breadcrumbsItemFn.recipeFn), {
  __recipe__: true,
  __name__: 'breadcrumbsItem',
  __getCompoundVariantCss__: breadcrumbsItemFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: breadcrumbsItemVariantKeys,
  variantMap: breadcrumbsItemVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, breadcrumbsItemVariantKeys)
  },
  getVariantProps: breadcrumbsItemFn.getVariantProps,
})